const v28 = (state: any) => {
  return {
    ...state,
    filters: {
      ...state.filters,
      freelancerFilters: {
        ...state.filters.freelancerFilters,
      },
    },
  };
};

export default v28;
